import React from "react";

const FunFact = (props) => {
  const funfact = [
    {
      title: "1500+",
      subTitle: "Clientes atendidos",
    },
    {
      title: "3000+",
      subTitle: "Consultorias realizadas",
    },
    {
      title: "100%",
      subTitle: "Clientes satisfeitos",
    },
    {
      title: "350+",
      subTitle: "Empresas parceiras",
    },
  ];

  return (
    <section className={`wpo-fun-fact-section  ${props.fnClass}`}>
      <div className="container">
        <div className="row">
          <div className="col col-xs-12">
            <div className="wpo-fun-fact-grids clearfix">
              {funfact.map((funfact, fitem) => (
                <div className="grid" key={fitem}>
                  <div className="info">
                    <h3>{funfact.title}</h3>
                    <p>{funfact.subTitle}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FunFact;
